var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRejected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#F25B5B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.22404L10.5355 11.7596C10.6958 11.9199 10.8998 12 11.1475 12C11.3953 12 11.5993 11.9199 11.7596 11.7596C11.9199 11.5993 12 11.3953 12 11.1475C12 10.8998 11.9199 10.6958 11.7596 10.5355L9.22404 8L11.7596 5.46448C11.9199 5.30419 12 5.10018 12 4.85246C12 4.60474 11.9199 4.40073 11.7596 4.24044C11.5993 4.08015 11.3953 4 11.1475 4C10.8998 4 10.6958 4.08015 10.5355 4.24044L8 6.77596L5.46448 4.24044C5.30419 4.08015 5.10018 4 4.85246 4C4.60474 4 4.40073 4.08015 4.24044 4.24044C4.08015 4.40073 4 4.60474 4 4.85246C4 5.10018 4.08015 5.30419 4.24044 5.46448L6.77596 8L4.24044 10.5355C4.08015 10.6958 4 10.8998 4 11.1475C4 11.3953 4.08015 11.5993 4.24044 11.7596C4.40073 11.9199 4.60474 12 4.85246 12C5.10018 12 5.30419 11.9199 5.46448 11.7596L8 9.22404Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejected);
export default __webpack_public_path__ + "static/media/rejected.4f715fa700538f5a2aa2c36eff2c84fc.svg";
export { ForwardRef as ReactComponent };